export enum OriginType {
    CampaniaMarketing = 'Campaña Marketing',
    SitioSeguro = 'Sitio Seguro',
    Microsite = 'Microsite'
}
